import { ApplicationStatus } from 'graphql/__generated__/graphql';

export const getStatusDisplay = (applicationStatus: ApplicationStatus) => {
    switch (applicationStatus) {
        case ApplicationStatus.ApplicantDraft:
            return 'In Progress';
        case ApplicationStatus.EmdrAwaitingReview:
            return 'Awaiting EMDR review';
        case ApplicationStatus.EmdrReviewInProgress:
            return 'EMDR review in progress';
        case ApplicationStatus.SupervisorReviewInProgress:
            return 'Supervisor review in progress';
        case ApplicationStatus.ApplicantReadyForSupervisorReview:
            return 'Ready for supervisor review';
        case ApplicationStatus.ApplicantReadyForEmdr:
            return 'Reviews complete';
        case ApplicationStatus.ApplicantRevisionsFromSupervisor:
        case ApplicationStatus.ApplicantRevisionsFromEmdr:
            return 'One or more items need your attention';
        case ApplicationStatus.EmdrApproved:
            return 'Approved';
        default:
            return 'Status unknown';
    }
};

export const getBadgeClass = (status?: ApplicationStatus): string => {
    if (!status) return '';
    return `app-status-${status.toLowerCase().replaceAll('_', '-')}`;
};

export const isApplicantEditable = (applicationStatus?: ApplicationStatus): boolean => {
    return (
        applicationStatus === undefined ||
        applicationStatus === ApplicationStatus.ApplicantDraft ||
        applicationStatus === ApplicationStatus.ApplicantRevisionsFromSupervisor ||
        applicationStatus === ApplicationStatus.ApplicantRevisionsFromEmdr ||
        applicationStatus === ApplicationStatus.ApplicantReadyForSupervisorReview
    );
};
